import { render, staticRenderFns } from "./userDashboardTrainingPlans.vue?vue&type=template&id=3e822a4e&scoped=true"
import script from "./userDashboardTrainingPlans.vue?vue&type=script&lang=js"
export * from "./userDashboardTrainingPlans.vue?vue&type=script&lang=js"
import style0 from "./userDashboardTrainingPlans.vue?vue&type=style&index=0&id=3e822a4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e822a4e",
  null
  
)

export default component.exports